module.exports = __webpack_public_path__ + "media/images/front/home_video-bd527d3cc08714328e979fedfb66820e.webm";